<template lang="pug">
  .introNav
    .introContainer
      .introNavBlock(v-for="item in introProArray")
        .introproBlock1 {{ item.title }}
          .intropro1
            router-link.intropro1Text(v-for="pro in item.pro" :to="'/project/' + pro.proid" :class="{selected: Number($route.params.projectid) === Number(pro.proid) }") {{ pro.title }}



  </template>

  <script>
  export default {
    data() {
      return {
        selected: '',
        introProArray: [

          {
            title: '人才培育',
            pro: [
              // {
              //   title: '推動幼兒園教育階段師資生美感素養提升計畫',
              //   proid: '1',
              // },
              // {
              //   title: '中小學師資生美感素養培力課程發展計畫 ',
              //   proid: '2',
              // },
              {
                title: '中小學師資生美感素養培力課程發展計畫',
                proid: '4',
              },
              {
                title: '中小學在職教師暨行政人員美感素養提升計畫',
                proid: '5',
              },
              {
                title: '美感教育出國計畫',
                proid: '6',
              },


            ],
          },
          {
            title: '課程實踐',
            pro: [
              // {
              //   title: '藝術與美感深根計畫',
              //   proid: '7',
              // },
              {
                title: '幼兒園美感教育扎根計畫',
                proid: '8',
              },
              {
                title: '跨領域美感教育卓越領航計畫 ',
                proid: '9',
              },
              {
                title: '美感與設計課程創新計畫',
                proid: '10',
              },
              {
                title: '樂器銀行',
                proid: '11',
              },
              {
                title: '偏鄉藝術美感育苗計畫',
                proid: '12',
              },
              {
                title: '好優Show學生藝團活動',
                proid: '13',
              },
              // {
              //   title: '藝起來學學－臺灣藝術與人文教育啟蒙計畫',
              //   proid: '7',
              // },
              {
                title: '廣達游於藝計畫',
                proid: '14',
              },
              {
                title: '廣達設計學習計畫',
                proid: '15',
              },
              // {
              //   title: '藝起來學學－臺灣美感教育啟蒙計畫',
              //   proid: '16',
              // },
              {
                title: '驚嘆號－臺灣原住民族群永續教育計畫',
                proid: '17',
              },
              {
                title: '文化美感輕旅行',
                proid: '18',
              },
              {
                title: '藝起來尋美－教育部推動國民中小學辦理美感體驗教育計畫',
                proid: '19',
              },
              {
                title: '大學推動藝術與美感素養導向先修課程計畫',
                proid: '23',
              },
              {
                title: '藝師藝有-鼓勵學校延聘在地文化工作者或傳統藝師計畫',
                proid: '26',
              },



            ],
          },
          {
            title: '學習環境',
            pro: [
              {
                title: '學美．美學－校園美感設計實踐計畫',
                proid: '21',
              },
              {
                title: '見美．踐美．漸美－建構美感生活學習地圖之方案實踐實施計畫',
                proid: '99',
              },
              {
                title: '校園美感環境再造計畫 ',
                proid: '22',
              },
              {
                title:'境善．境美 - 學習環境美感涵養計畫',
                proid: '24',
              }
            ],
          },
          {
            title: '支持體系',
            pro: [
              {
                title: '美感教育資源整合平臺維護計畫',
                proid: '1',
              },
              {
                title: '亞太地區美感教育研究室',
                proid: '2',
              },
              {
                title: '團團有美感教學輔導網絡計畫',
                proid: '3',
              },
            ],
          },
          {
            title: '其他',
            pro: [

              {
                title: '各級學校教育人員生活美感電子書發展計畫 ',
                proid: '98',
              },
              {
                title: '《本土音樂教材編選指引II》—臺灣閩南語歌曲補充教材(國小中年級)',
                proid: '97',
              },

            ],
          },
        ],
      };
    },

  }
  </script>

  <style lang="sass">
  @import "@/assets/style.sass"

  .introNav
    position: relative
    width: 100%
    .introContainer
      background-color: #EFEFEF
      +flexcolumn
      padding: 15px
      box-sizing: border-box
      .introNavBlock
        width: 100%
        position: relative
        .introproBlock1
          +font
          +c
          font-size: 16px
          cursor: pointer
          color: #BBB
          &.active
            color: $colorBrown
          .intropro1
            +flexcolumn
            margin-top: 10px
            margin-bottom: 10px
            .intropro1Text
              color: #333
              font-size: 18px
              text-decoration: none
              margin-bottom: 5px
              &.selected
                font-weight: bold
                color: #000
                transform: none !important







  </style>



// WEBPACK FOOTER //
// src/views/Intro/IntroNav.vue